import React from "react";

export interface GroupItem {
    title?: string;
    detail?: string;
    onOptionsClick?: () => void;
    icon?: string;
    time?: string;
    text?: string;
  
}

export interface GroupSectionProps {
    title: string;
    items: GroupItem[];
    action?: () => void;
    
}

const BlurredData = ({ text }: { text: string }) => {
    return (
      <div className="blurred-data">
        <span className="blurred" title="Diese Daten jetzt freischalten">
          {text}
        </span>
        <i className="fa-solid fa-lock" />
      </div>
    );
  };
  

const GroupSection: React.FC<GroupSectionProps> = ({ action, title, items }) => {


    return (
        <div className="group-section" onClick={action}>

            <div className="group-header">

                <h3 className="group-title">{title}</h3>
                <i className="fa-solid fa-plus" style={{ fontSize: "20px", fontWeight: "bold" }} />
            </div>
            <div className="group-items">
                {items.map((item, index) => (
                    <div key={index} className="group-item">
                        <div className="group-item-text">
                            {item && item.title && item.title.length > 0 &&
                        <BlurredData text={item.title} /> 
                            }
                            <div className="group-item-detail">{item.detail}</div>
                        </div>
                        <div className="group-item-options">
                            <i onClick={item.onOptionsClick} className="fa-solid fa-ellipsis-vertical" />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default GroupSection;
